export default {"src":"/_next/static/media/icon-facebook.5f711742.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};